import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
  path: '/goodsDelivery',
  name: 'goodsDelivery',
  title: '发货管理',
  icon: 'truck',
  meta,
  redirect: { name: 'delivery-apply-list' },
  component: layoutHeaderAside,
  children: (pre => [
    // 待发货统计
    {
      path: 'delivery-stats',
      name: 'delivery-stats',
      component: _import('goodsDelivery/deliveryStats'),
      meta: {
        ...meta,
        title: '待发货统计'
      }
    },
    // 发货店铺列表
    {
      path: 'deliveryShopList',
      name: 'delivery-shop-list',
      component: _import('goodsDelivery/deliveryShopList'),
      meta: {
        ...meta,
        title: '发货店铺列表'
      }
    },
    // 生成发货单预览
    {
      path: 'deliveryPreview',
      name: 'delivery-preview',
      component: _import('goodsDelivery/deliveryPreview'),
      meta: {
        ...meta,
        title: '生成发货单'
      }
    },
    // 发货单列表
    {
      path: 'deliveryList',
      name: 'delivery-list',
      component: _import('goodsDelivery/deliveryList'),
      meta: {
        ...meta,
        title: '发货单列表'
      }
    },
    // 发货申请单列表
    {
      path: 'deliveryApplyList',
      name: 'delivery-apply-list',
      component: _import('goodsDelivery/deliveryApplyList'),
      meta: {
        ...meta,
        title: '发货申请单列表'
      }
    },
    // 收货订单管理
    {
      path: 'shop/receiveList',
      name: 'receive-list',
      component: _import('goodsDelivery/receiveList'),
      meta: {
        ...meta,
        title: '收货订单管理'
      }
    },
    // 收货订单详情
    {
      path: 'shop/receiveDetail',
      name: 'receive-detail',
      component: _import('goodsDelivery/receiveDetail'),
      meta: {
        ...meta,
        title: '收货订单详情'
      }
    },
    // 发货单详情
    {
      path: 'deliveryDetail',
      name: 'delivery-detail',
      component: _import('goodsDelivery/deliveryDetail'),
      meta: {
        ...meta,
        title: '发货单详情'
      }
    },
    // 发货方管理（原有）
    {
      path: 'shipper/list',
      name: `shipper-list`,
      component: _import('goodsDelivery/shipperList'),
      meta: {
        ...meta,
        title: '发货方列表'
      }
    },
    {
      path: 'shipper/add',
      name: 'shipper-add',
      component: _import('goodsDelivery/shipperAdd'),
      meta: {
        ...meta,
        title: '新增发货方'
      }
    },
    {
      path: 'shipper/detail',
      name: 'shipper-detail',
      component: _import('goodsDelivery/shipperDetail'),
      meta: {
        ...meta,
        title: '发货方详情'
      }
    },
    {
      path: 'shipper/goodsList',
      name: 'shipper-goods-list',
      component: _import('goodsDelivery/shipperGoodsList'),
      meta: {
        ...meta,
        title: '发货方已绑定商品'
      }
    },
    // 网点收货管理
    {
      path: 'branch/receiveList',
      name: 'branch-receive-list',
      component: _import('goodsDelivery/branchReceiveList'),
      meta: {
        ...meta,
        title: '网点收货单列表'
      }
    },
    {
      path: 'branch/receiveDetail',
      name: 'branch-receive-detail',
      component: _import('goodsDelivery/branchReceiveDetail'),
      meta: {
        ...meta,
        title: '收货单详情'
      }
    },
    // 网点管理
    {
      path: 'branch/list',
      name: 'branch-list',
      component: _import('goodsDelivery/branchList'),
      meta: {
        ...meta,
        title: '网点列表'
      }
    },
    {
      path: 'branch/add',
      name: 'branch-add',
      component: _import('goodsDelivery/branchAdd'),
      meta: {
        ...meta,
        title: '新增网点'
      }
    },
    {
      path: 'branch/edit',
      name: 'branch-edit',
      component: _import('goodsDelivery/branchEdit'),
      meta: {
        ...meta,
        title: '编辑网点'
      }
    }
  ])('goodsDelivery-')
}
